import React from 'react'
import { useRecoilValue } from 'recoil'
import { DataTable, Text } from '@/presentation/components'
import { serviceOrderDetailState } from '@/presentation/pages/ServiceOrderDetail/components'
import { DateAdapter } from '@/data/protocols'
import { styles } from '../../styles'

type OsProblemsProps = {
  dateAdapter: DateAdapter
}

export const OsProblems: React.FC<OsProblemsProps> = ({
  dateAdapter
}) => {
  const serviceOrderDetail = useRecoilValue(serviceOrderDetailState)

  return (
    <>
      {!!serviceOrderDetail.listaProblemas?.length &&
        <>
          <Text style={styles.pageInfo}>Problema Relatados na Ordem de Serviço</Text>
          <DataTable>
            <DataTable.Header>
              <DataTable.Title>Relato</DataTable.Title>
              <DataTable.Title>Resolução</DataTable.Title>
              <DataTable.Title>Origem</DataTable.Title>
              <DataTable.Title>Problema Relacionado</DataTable.Title>
            </DataTable.Header>

            {serviceOrderDetail.listaProblemas.map((problema, index) => (
              <>
                <DataTable.Row key={index}>
                  <DataTable.Cell>{dateAdapter.format(problema.dataInicial, 'DD/MM/yyyy hh:mm')}</DataTable.Cell>
                  <DataTable.Cell>{dateAdapter.format(problema.dataFinal, 'DD/MM/yyyy hh:mm')}</DataTable.Cell>
                  <DataTable.Cell>{problema.origem}</DataTable.Cell>
                  <DataTable.Cell>{problema.strProblema}</DataTable.Cell>
                </DataTable.Row>
                {problema.pendencia &&
                  <DataTable.Row>
                    <DataTable.Cell><span style={styles.additionalText}>{problema.pendencia}</span></DataTable.Cell>
                  </DataTable.Row>
                }
              </>
            ))}
          </DataTable>
        </>
      }
    </>
  )
}
